// 初始化操作
export const INIT_SIDE_MENU = 'INIT_SIDE_MENU';

// Login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const GET_LOGIN_CODE = 'GET_LOGIN_CODE';
export const IMG_CODE_UPDATE = 'IMG_CODE_UPDATE';
export const USERNAME_UPDATE = 'USERNAME_UPDATE';
export const SET_INFO_FROM_LOCAL = 'SET_INFO_FROM_LOCAL';
export const GET_USER_AUTH_SUCCESS = 'GET_USER_AUTH_SUCCESS';
export const SET_AUTHROUTER = 'SET_AUTHROUTER';

// Home
export const GET_INDEX_ARTICLES_REQUEST = 'GET_INDEX_ARTICLES_REQUEST';
export const GET_INDEX_ARTICLES_SUCCESS = 'GET_INDEX_ARTICLES_SUCCESS';
export const GET_INDEX_ARTICLES_FAILURE = 'GET_INDEX_ARTICLES_FAILURE';
export const GET_INDEX_ORDER_COUNT_REQUEST = 'GET_INDEX_ORDER_COUNT_REQUEST';
export const GET_INDEX_ORDER_COUNT_SUCCESS = 'GET_INDEX_ORDER_COUNT_SUCCESS';
export const GET_INDEX_ORDER_COUNT_FAILURE = 'GET_INDEX_ORDER_COUNT_FAILURE';
export const GET_INDEX_NOTICE_REQUEST = 'GET_INDEX_NOTICE_REQUEST';
export const GET_INDEX_NOTICE_SUCCESS = 'GET_INDEX_NOTICE_SUCCESS';
export const GET_INDEX_NOTICE_FAILURE = 'GET_INDEX_NOTICE_FAILURE';
export const GET_PREDICT_COUNT_REQUEST = 'GET_PREDICT_COUNT_REQUEST';
export const GET_PREDICT_COUNT_SUCCESS = 'GET_PREDICT_COUNT_SUCCESS';
export const GET_PREDICT_COUNT_FAILURE = 'GET_PREDICT_COUNT_FAILURE';
export const UPDATE_PREDICT_SHOW = 'UPDATE_PREDICT_SHOW';

// IncomeOverview
export const GET_RECENT_INCOME_REQUEST = 'GET_RECENT_INCOME_REQUEST';
export const GET_RECENT_INCOME_SUCCESS = 'GET_RECENT_INCOME_SUCCESS';
export const GET_RECENT_INCOME_FAILURE = 'GET_RECENT_INCOME_FAILURE';
export const GET_RECENT_PC_INCOME_REQUEST = 'GET_RECENT_PC_INCOME_REQUEST';
export const GET_RECENT_PC_INCOME_SUCCESS = 'GET_RECENT_PC_INCOME_SUCCESS';
export const GET_RECENT_PC_INCOME_FAILURE = 'GET_RECENT_PC_INCOME_FAILURE';
export const GET_RECENT_ORDER_COUNT_REQUEST = 'GET_RECENT_ORDER_COUNT_REQUEST';
export const GET_RECENT_ORDER_COUNT_SUCCESS = 'GET_RECENT_ORDER_COUNT_SUCCESS';
export const GET_RECENT_ORDER_COUNT_FAILURE = 'GET_RECENT_ORDER_COUNT_FAILURE';
export const GET_RECENT_CAR_INCOME_REQUEST = 'GET_RECENT_CAR_INCOME_REQUEST';
export const GET_RECENT_CAR_INCOME_SUCCESS = 'GET_RECENT_CAR_INCOME_SUCCESS';
export const GET_RECENT_CAR_INCOME_FAILURE = 'GET_RECENT_CAR_INCOME_FAILURE';

// incomeList
export const GET_INCOME_LIST_REQUEST = 'GET_INCOME_LIST_REQUEST';
export const GET_INCOME_LIST_SUCCESS = 'GET_INCOME_LIST_SUCCESS';
export const GET_INCOME_LIST_FAILURE = 'GET_INCOME_LIST_FAILURE';
export const UPDATE_INCOME_LIST_PARAMS = 'UPDATE_INCOME_LIST_PARAMS';
export const RESET_INCOME_LIST = 'RESET_INCOME_LIST';
export const RESOLVE_INCOME_LIST_PARAMS = 'RESOLVE_INCOME_LIST_PARAMS';

// orderDetail
export const GET_ORDER_DETAIL_REQUEST = 'GET_ORDER_DETAIL_REQUEST';
export const GET_ORDER_DETAIL_SUCCESS = 'GET_ORDER_DETAIL_SUCCESS';
export const GET_ORDER_DETAIL_FAILURE = 'GET_ORDER_DETAIL_FAILURE';
export const UPDATE_ORDER_DETAIL_PARAMS = 'UPDATE_ORDER_DETAIL_PARAMS';

// printOrder 打印页面
export const GET_PRINT_ORDER_DETAIL_REQUEST = 'GET_PRINT_ORDER_DETAIL_REQUEST';
export const GET_PRINT_ORDER_DETAIL_SUCCESS = 'GET_PRINT_ORDER_DETAIL_SUCCESS';
export const GET_PRINT_ORDER_DETAIL_FAILURE = 'GET_PRINT_ORDER_DETAIL_FAILURE';
export const UPDATE_PRINT_ORDER_DETAIL_PARAMS = 'UPDATE_PRINT_ORDER_DETAIL_PARAMS';

// workerOrderDetail 接车订单详情
export const GET_WORKER_ORDER_DETAIL_REQUEST = 'GET_WORKER_ORDER_DETAIL_REQUEST';
export const GET_WORKER_ORDER_DETAIL_SUCCESS = 'GET_WORKER_ORDER_DETAIL_SUCCESS';
export const GET_WORKER_ORDER_DETAIL_FAILURE = 'GET_WORKER_ORDER_DETAIL_FAILURE';
export const UPDATE_WORKER_ORDER_DETAIL_PARAMS = 'UPDATE_WORKER_ORDER_DETAIL_PARAMS';
export const UPDATE_WORKER_ORDER_DETAIL_REMAINPAYTIME = 'UPDATE_WORKER_ORDER_DETAIL_REMAINPAYTIME';
export const UPDATE_WORKER_ORDER_DETAIL_SERVER_INFO = 'UPDATE_WORKER_ORDER_DETAIL_SERVER_INFO';
export const UPDATE_WORKER_ORDER_DETAIL_SERVERINFO_SUCCESS = 'UPDATE_WORKER_ORDER_DETAIL_SERVERINFO_SUCCESS';

// orderList
export const GET_ORDER_LIST_REQUEST = 'GET_ORDER_LIST_REQUEST';
export const GET_ORDER_LIST_SUCCESS = 'GET_ORDER_LIST_SUCCESS';
export const GET_ORDER_LIST_FAILURE = 'GET_ORDER_LIST_FAILURE';
export const UPDATE_ORDER_LIST = 'UPDATE_ORDER_LIST';
export const UPDATE_ORDER_LIST_PARAMS = 'UPDATE_ORDER_LIST_PARAMS';
export const UPDATE_EXPORT_ORDER_URL = 'UPDATE_EXPORT_ORDER_URL';
export const UPDATE_WAIT_DATA = 'UPDATE_WAIT_DATA';
export const RESET_ORDER_LIST = 'RESET_ORDER_LIST';
export const RESOLVE_ORDER_LIST_PARAMS = 'RESOLVE_ORDER_LIST_PARAMS';

// workerOrderList 接车订单列表
export const GET_WORKER_ORDER_LIST_REQUEST = 'GET_WORKER_ORDER_LIST_REQUEST';
export const GET_WORKER_ORDER_LIST_SUCCESS = 'GET_WORKER_ORDER_LIST_SUCCESS';
export const GET_WORKER_ORDER_LIST_FAILURE = 'GET_WORKER_ORDER_LIST_FAILURE';
export const UPDATE_WORKER_ORDER_LIST = 'UPDATE_WORKER_ORDER_LIST';
export const UPDATE_WORKER_ORDER_LIST_PARAMS = 'UPDATE_WORKER_ORDER_LIST_PARAMS';
export const UPDATE_WORKER_EXPORT_ORDER_URL = 'UPDATE_WORKER_EXPORT_ORDER_URL';
export const UPDATE_WORKER_WAIT_DATA = 'UPDATE_WORKER_WAIT_DATA';
export const RESET_WORKER_ORDER_LIST = 'RESET_WORKER_ORDER_LIST';
export const RESOLVE_WORKER_ORDER_LIST_PARAMS = 'RESOLVE_WORKER_ORDER_LIST_PARAMS';


// historyList
export const GET_HISTORY_LIST_REQUEST = 'GET_HISTORY_LIST_REQUEST';
export const GET_HISTORY_LIST_SUCCESS = 'GET_HISTORY_LIST_SUCCESS';
export const GET_HISTORY_LIST_FAILURE = 'GET_HISTORY_LIST_FAILURE';
export const UPDATE_HISTORY_LIST = 'UPDATE_HISTORY_LIST';
export const UPDATE_HISTORY_LIST_PARAMS = 'UPDATE_HISTORY_LIST_PARAMS';
export const RESET_HISTORY_LIST = 'RESET_HISTORY_LIST';
export const RESOLVE_HISTORY_LIST_PARAMS = 'RESOLVE_HISTORY_LIST_PARAMS';

// carNo
export const GET_CAR_SHORT_REQUEST = 'GET_CAR_SHORT_REQUEST';
export const GET_CAR_SHORT_SUCCESS = 'GET_CAR_SHORT_SUCCESS';
export const GET_CAR_SHORT_FAILURE = 'GET_CAR_SHORT_FAILURE';
export const GET_CAR_LETTER_REQUEST = 'GET_CAR_LETTER_REQUEST';
export const GET_CAR_LETTER_SUCCESS = 'GET_CAR_LETTER_SUCCESS';
export const GET_CAR_LETTER_FAILURE = 'GET_CAR_LETTER_FAILURE';

// carBrand, carLine, carModel
export const GET_CAR_BRAND_REQUEST = 'GET_CAR_BRAND_REQUEST';
export const GET_CAR_BRAND_SUCCESS = 'GET_CAR_BRAND_SUCCESS';
export const GET_CAR_BRAND_FAILURE = 'GET_CAR_BRAND_FAILURE';
export const GET_CAR_LINE_REQUEST = 'GET_CAR_LINE_REQUEST';
export const GET_CAR_LINE_SUCCESS = 'GET_CAR_LINE_SUCCESS';
export const GET_CAR_LINE_FAILURE = 'GET_CAR_LINE_FAILURE';
export const GET_CAR_MODEL_REQUEST = 'GET_CAR_MODEL_REQUEST';
export const GET_CAR_MODEL_SUCCESS = 'GET_CAR_MODEL_SUCCESS';
export const GET_CAR_MODEL_FAILURE = 'GET_CAR_MODEL_FAILURE';
export const CLEAR_LINE_DATA = 'CLEAR_LINE_DATA';
export const CLEAR_MODEL_DATA = 'CLEAR_MODEL_DATA';

// serviceList
export const GET_SERVICE_LIST_REQUEST = 'GET_SERVICE_LIST_REQUEST';
export const GET_SERVICE_LIST_SUCCESS = 'GET_SERVICE_LIST_SUCCESS';
export const GET_SERVICE_LIST_FAILURE = 'GET_SERVICE_LIST_FAILURE';
export const SERVICE_LIST_CHOOSE_ITEM = 'SERVICE_LIST_CHOOSE_ITEM';
export const SERVICE_LIST_CHOOSE_ADD_ITEM = 'SERVICE_LIST_CHOOSE_ADD_ITEM';
export const EDIT_SERVICVE_ITEM_PROPS = 'EDIT_SERVICVE_ITEM_PROPS';
export const UPDATE_CHOSEN_SERVICE_IDS = 'UPDATE_CHOSEN_SERVICE_IDS';
export const UPDATE_CHOSEN_SERVICE_WORKERS = 'UPDATE_CHOSEN_SERVICE_WORKERS';
// export const CUSTOMIZE_SERVICE_CACHE = 'CUSTOMIZE_SERVICE_CACHE';
export const SERVICE_LIST_CONFIG_RESET = 'SERVICE_LIST_CONFIG_RESET';
export const INIT_NUM = 'INIT_NUM';
// 爱车卡核销
export const SERIALIZE_CARD_FOR_SERVICE = 'SERIALIZE_CARD_FOR_SERVICE';
export const UPDATE_CARD_FOR_SERVICE = 'UPDATE_CARD_FOR_SERVICE';

// 订单初始化服务
export const INIT_ORDER_CHOSEN_SERVICE = 'INIT_ORDER_CHOSEN_SERVICE';
export const INIT_ORDER_CHOSEN_SERVICE_IDS = 'INIT_ORDER_CHOSEN_SERVICE_IDS';
// goodsList
export const GET_GOODS_CATES_REQUEST = 'GET_GOODS_CATES_REQUEST';
export const GET_GOODS_CATES_SUCCESS = 'GET_GOODS_CATES_SUCCESS';
export const GET_GOODS_CATES_FAILURE = 'GET_GOODS_CATES_FAILURE';
export const GET_GOODS_LIST_REQUEST = 'GET_GOODS_LIST_REQUEST';
export const GET_GOODS_LIST_SUCCESS = 'GET_GOODS_LIST_SUCCESS';
export const GET_GOODS_LIST_FAILURE = 'GET_GOODS_LIST_FAILURE';
export const CLEAR_GOODS_CATES_BY_LEVEL = 'CLEAR_GOODS_CATES_BY_LEVEL';
export const UPDATE_GOODS_LIST_PARAMS = 'UPDATE_GOODS_LIST_PARAMS';
export const GOODS_LIST_CHOSEN_ITEM = 'GOODS_LIST_CHOSEN_ITEM';
export const GOODS_LIST_CHOSEN_ADD_ITEM = 'GOODS_LIST_CHOSEN_ADD_ITEM';
export const EDIT_GOODS_ITEM_PROPS = 'EDIT_GOODS_ITEM_PROPS';
export const UPDATE_CHOSEN_GOODS_IDS = 'UPDATE_CHOSEN_GOODS_IDS';
export const GOODS_LIST_CONFIG_RESET = 'GOODS_LIST_CONFIG_RESET';

export const GET_GOODS_TEMP_LIST_REQUEST = 'GET_GOODS_TEMP_LIST_REQUEST';
export const GET_GOODS_TEMP_LIST_SUCCESS = 'GET_GOODS_TEMP_LIST_SUCCESS';
export const GET_GOODS_TEMP_LIST_FAILURE = 'GET_GOODS_TEMP_LIST_FAILURE';
export const GOODS_TEMP_LIST_CHOOSE_ADD_ITEM = 'GOODS_TEMP_LIST_CHOOSE_ADD_ITEM';
export const TEMP_GOODS_CACHE = 'TEMP_GOODS_CACHE';
// 订单初始化商品
export const INIT_ORDER_CHOSEN_GOODS = 'INIT_ORDER_CHOSEN_GOODS';
export const INIT_ORDER_CHOSEN_GOODS_IDS = 'INIT_ORDER_CHOSEN_GOODS_IDS';

// workers
export const GET_STORE_WORKERS_REQUEST = 'GET_STORE_WORKERS_REQUEST';
export const GET_STORE_WORKERS_SUCCESS = 'GET_STORE_WORKERS_SUCCESS';
export const GET_STORE_WORKERS_FAILURE = 'GET_STORE_WORKERS_FAILURE';


// recent carNo
export const GET_RECNET_CARNO_REQUEST = 'GET_RECNET_CARNO_REQUEST';
export const GET_RECNET_CARNO_SUCCESS = 'GET_RECNET_CARNO_SUCCESS';
export const GET_RECNET_CARNO_FAILURE = 'GET_RECNET_CARNO_FAILURE';
// 车辆详情
export const GET_RECNET_COMPANY_REQUEST = 'GET_RECNET_COMPANY_REQUEST';
export const GET_RECNET_COMPANY_SUCCESS = 'GET_RECNET_COMPANY_SUCCESS';
export const GET_RECNET_COMPANY_FAILURE = 'GET_RECNET_COMPANY_FAILURE';

// orders undone
export const GET_ORDER_UNDONE_BY_CARNO_REQUEST = 'GET_ORDER_UNDONE_BY_CARNO_REQUEST';
export const GET_ORDER_UNDONE_BY_CARNO_SUCCESS = 'GET_ORDER_UNDONE_BY_CARNO_SUCCESS';
export const GET_ORDER_UNDONE_BY_CARNO_FAILURE = 'GET_ORDER_UNDONE_BY_CARNO_FAILURE';

// edit order
export const POST_ORDER_CREATE_REQUEST = 'POST_ORDER_CREATE_REQUEST';
export const POST_ORDER_CREATE_SUCCESS = 'POST_ORDER_CREATE_SUCCESS';
export const POST_ORDER_CREATE_FAILURE = 'POST_ORDER_CREATE_FAILURE';
export const POST_ORDER_CREATE_RESET   = 'POST_ORDER_CREATE_RESET';
export const GET_USER_STORE_CARDS_REQUEST = 'GET_USER_STORE_CARDS_REQUEST';
export const GET_USER_STORE_CARDS_SUCCESS = 'GET_USER_STORE_CARDS_SUCCESS';
export const GET_USER_STORE_CARDS_FAILURE = 'GET_USER_STORE_CARDS_FAILURE';
export const CHANGE_EDIT_STATE = 'CHANGE_EDIT_STATE';
export const GET_BOUGHT_SERVICE_LIST_SUCCESS = 'GET_BOUGHT_SERVICE_LIST_SUCCESS';
export const GET_BOUGHT_SERVICE_LIST_FAILURE = 'GET_BOUGHT_SERVICE_LIST_FAILURE';
export const TEMPORARY_SERVICE_CACHE = 'TEMPORARY_SERVICE_CACHE';
export const TEMPORARY_SERVICE_DOUBLE_NAME = 'TEMPORARY_SERVICE_DOUBLE_NAME';
export const GET_WRITEOFF_AUTH = 'GET_WRITEOFF_AUTH';

// store card list
export const GET_STORE_CARD_LIST_REQUEST = 'GET_STORE_CARD_LIST_REQUEST';
export const GET_STORE_CARD_LIST_SUCCESS = 'GET_STORE_CARD_LIST_SUCCESS';
export const GET_STORE_CARD_LIST_FAILURE = 'GET_STORE_CARD_LIST_FAILURE';

// maintenance
export const GET_MAINTENANCE_INFO_REQUEST = 'GET_MAINTENANCE_INFO_REQUEST';
export const GET_MAINTENANCE_INFO_SUCCESS = 'GET_MAINTENANCE_INFO_SUCCESS';
export const GET_MAINTENANCE_INFO_FAILURE = 'GET_MAINTENANCE_INFO_FAILURE';
export const MAINTENANCE_ID_UPDATE = 'MAINTENANCE_ID_UPDATE';


// client promot
export const GET_CLIENT_LIST_PROMOT_REQUEST = 'GET_CLIENT_LIST_PROMOT_REQUEST';
export const GET_CLIENT_LIST_PROMOT_SUCCESS = 'GET_CLIENT_LIST_PROMOT_SUCCESS';
export const GET_CLIENT_LIST_PROMOT_FAILURE = 'GET_CLIENT_LIST_PROMOT_FAILURE';
export const GET_STORE_PROMOT_CONFIG_REQUEST = 'GET_STORE_PROMOT_CONFIG_REQUEST';
export const GET_STORE_PROMOT_CONFIG_SUCCESS = 'GET_STORE_PROMOT_CONFIG_SUCCESS';
export const GET_STORE_PROMOT_CONFIG_FAILURE = 'GET_STORE_PROMOT_CONFIG_FAILURE';
export const RESOLVE_CLIENT_PROMOT_USER_LIST_PARAMS = 'RESOLVE_CLIENT_PROMOT_USER_LIST_PARAMS';
export const UPDATE_CLIENT_PROMOT_CONFIG = 'UPDATE_CLIENT_PROMOT_CONFIG';
export const UPDATE_CLIENT_LIST_STATUS = 'UPDATE_CLIENT_LIST_STATUS';
export const GET_CARS_BY_MOBILE_REQUEST = 'GET_CARS_BY_MOBILE_REQUEST';
export const GET_CARS_BY_MOBILE_SUCCESS = 'GET_CARS_BY_MOBILE_SUCCESS';
export const GET_CARS_BY_MOBILE_FAILURE = 'GET_CARS_BY_MOBILE_FAILURE';
export const RESET_CLIENT_PROMOT_STATE = 'RESET_CLIENT_PROMOT_STATE';


// prePaidEdit
export const GET_STORE_CHARGE_CARD_LIST_REQUEST = 'GET_STORE_CHARGE_CARD_LIST_REQUEST';
export const GET_STORE_CHARGE_CARD_LIST_SUCCESS = 'GET_STORE_CHARGE_CARD_LIST_SUCCESS';
export const GET_STORE_CHARGE_CARD_LIST_FAILURE = 'GET_STORE_CHARGE_CARD_LIST_FAILURE';
export const STORE_CHARGE_CARD_LIST_ITEM_EDIT   = 'STORE_CHARGE_CARD_LIST_ITEM_EDIT';

// client list
export const GET_CLIENT_LIST_REQUEST = 'GET_CLIENT_LIST_REQUEST';
export const GET_CLIENT_LIST_SUCCESS = 'GET_CLIENT_LIST_SUCCESS';
export const GET_CLIENT_LIST_FAILURE = 'GET_CLIENT_LIST_FAILURE';
export const UPDATE_CLIENT_LIST_PARAMS = 'UPDATE_CLIENT_LIST_PARAMS';
export const RESET_CLIENT_LIST = 'RESET_CLIENT_LIST';
export const RESOLVE_CLIENT_LIST_PARAMS = 'RESOLVE_CLIENT_LIST_PARAMS';

// client detail
export const GET_USER_DETAIL_REQUEST = 'GET_USER_DETAIL_REQUEST';
export const GET_USER_DETAIL_SUCCESS = 'GET_USER_DETAIL_SUCCESS';
export const GET_USER_DETAIL_FAILURE = 'GET_USER_DETAIL_FAILURE';
export const RESOLVE_USER_DETAIL_PARAMS = 'RESOLVE_USER_DETAIL_PARAMS';
export const GET_USER_CAR_LIST_FAILURE = 'GET_USER_CAR_LIST_FAILURE';
export const GET_USER_CAR_LIST_SUCCESS = 'GET_USER_CAR_LIST_SUCCESS';
export const GET_USER_CAR_LIST_REQUEST = 'GET_USER_CAR_LIST_REQUEST';
export const RESOLVE_USER_CAR_LIST_PARAMS = 'RESOLVE_USER_CAR_LIST_PARAMS';
export const UPDATE_CLIENT_DETAIL_PARAMS = 'UPDATE_CLIENTDETAIL_PARAMS';

// cars
export const GET_CARS_REQUEST = 'GET_CARS_REQUEST';
export const GET_CARS_SUCCESS = 'GET_CARS_SUCCESS';
export const GET_CARS_FAILURE = 'GET_CARS_FAILURE';
export const UPDATE_CARS_PARAMS = 'UPDATE_CARS_PARAMS';
export const RESOLVE_CARS_PARAMS = 'RESOLVE_CARS_PARAMS';
export const RESET_CARS_STATE = 'RESET_CARS_STATE';

// cars detail
export const GET_CARS_DETAIL_REQUEST = 'GET_CARS_DETAIL_REQUEST';
export const GET_CARS_DETAIL_SUCCESS = 'GET_CARS_DETAIL_SUCCESS';
export const GET_CARS_DETAIL_FAILURE = 'GET_CARS_DETAIL_FAILURE';
export const UPDATE_CARS_DETAIL_PARAMS = 'UPDATE_CARS_DETAIL_PARAMS';
export const RESOLVE_CARS_DETAIL_PARAMS = 'RESOLVE_CARS_DETAIL_PARAMS';


export const GET_CARS_DETAIL_CAR_LIST_PARAMS = 'GET_CARS_DETAIL_CAR_LIST_PARAMS';
export const GET_CARS_DETAIL_CAR_LIST_SUCCESS = 'GET_CARS_DETAIL_CAR_LIST_SUCCESS';
export const GET_CARS_DETAIL_CAR_LIST_FAILURE = 'GET_CARS_DETAIL_CAR_LIST_FAILURE';
export const RESOLVE_CARS_DETAIL_CAR_LIST_PARAMS = 'RESOLVE_CARS_DETAIL_CAR_LIST_PARAMS';
export const SAVE_CAR_DETAIL_REQUEST = 'SAVE_CAR_DETAIL_REQUEST';
export const SAVE_CAR_DETAIL_SUCCESS = 'SAVE_CAR_DETAIL_SUCCESS';
export const SAVE_CAR_DETAIL_FAILURE = 'SAVE_CAR_DETAIL_FAILURE';
export const RESOLVE_SAVE_CAR_DETAIL_PARAMS = 'RESOLVE_SAVE_CAR_DETAIL_PARAMS';
export const CAR_DETAIL_RESET_DATA = 'CAR_DETAIL_RESET_DATA';

// prePaid record
export const GET_PREPAID_RECORD_LIST_REQUEST = 'GET_PREPAID_RECORD_LIST_REQUEST';
export const GET_PREPAID_RECORD_LIST_SUCCESS = 'GET_PREPAID_RECORD_LIST_SUCCESS';
export const GET_PREPAID_RECORD_LIST_FAILURE = 'GET_PREPAID_RECORD_LIST_FAILURE';
export const UPDATE_GET_PREPAID_PAGE_CONFIG = 'UPDATE_GET_PREPAID_PAGE_CONFIG';
export const UPDATE_GET_PREPAID_MOBILE_CONFIG = 'UPDATE_GET_PREPAID_MOBILE_CONFIG';
export const UPDATE_GET_PREPAID_PARAMS_CONFIG = 'UPDATE_GET_PREPAID_PARAMS_CONFIG';
export const GET_PRE_PAID_ORDER_FIX_RECORD = 'GET_PRE_PAID_ORDER_FIX_RECORD';
export const RESET_PRE_PAID_RECORD_STATE = 'RESET_PRE_PAID_RECORD_STATE';

// noticeList
export const GET_NOTELIST_REQUEST = 'GET_NOTELIST_REQUEST';
export const GET_NOTELIST_SUCCESS = 'GET_NOTELIST_SUCCESS';
export const GET_NOTELIST_FAILURE = 'GET_NOTELIST_FAILURE';

// logList
export const GET_LOGLIST_REQUEST = 'GET_LOGLIST_REQUEST';
export const GET_LOGLIST_SUCCESS = 'GET_LOGLIST_SUCCESS';
export const GET_LOGLIST_FAILURE = 'GET_LOGLIST_FAILURE';

export const GET_ORDERLIST_SUCCESS = 'GET_ORDERLIST_SUCCESS';
export const GET_ORDERLIST_FAILURE = 'GET_ORDERLIST_FAILURE';
export const GET_GOODSLIST_SUCCESS = 'GET_GOODSLIST_SUCCESS';

// staffList
export const GET_STAFF_LIST_REQUEST = 'GET_STAFF_LIST_REQUEST';
export const GET_STAFF_LIST_SUCCESS = 'GET_STAFF_LIST_SUCCESS';
export const GET_STAFF_LIST_FAILURE = 'GET_STAFF_LIST_FAILURE';
export const UPDATE_STAFF_LIST_PARAMS = 'UPDATE_STAFF_LIST_PARAMS';
export const RESOLVE_STAFF_LIST_PARAMS = 'RESOLVE_STAFF_LIST_PARAMS';
export const RESET_STAFF_LIST_DATA = '';

// staffEdit
export const GET_ALL_ROLE_FOR_EDIT = 'GET_ALL_ROLE_FOR_EDIT';
export const GET_WORKERS_FOR_EDIT_REQUEST = 'GET_WORKERS_FOR_EDIT_REQUEST';
export const GET_WORKERS_FOR_EDIT_SUCCESS = 'GET_WORKERS_FOR_EDIT_SUCCESS';
export const GET_WORKERS_FOR_EDIT_FAILURE = 'GET_WORKERS_FOR_EDIT_FAILURE';
export const RESET_STAFF_EDIT_DATA = 'RESET_STAFF_EDIT_DATA';

// operators
export const GET_OPERATORS_LIST_REQUEST = 'GET_OPERATORS_LIST_REQUEST';
export const GET_OPERATORS_LIST_SUCCESS = 'GET_OPERATORS_LIST_SUCCESS';
export const GET_OPERATORS_LIST_FAILURE = 'GET_OPERATORS_LIST_FAILURE';
export const UPDATE_OPERATORS_LIST_PARAMS = 'UPDATE_OPERATORS_LIST_PARAMS';
export const RESOLVE_OPERATORS_LIST_PARAMS = 'RESOLVE_OPERATORS_LIST_PARAMS';
export const RESET_OPERATORS_LIST = 'RESET_OPERATORS_LIST';
export const REMOVE_BIND_REQUEST = 'REMOVE_BIND_PARAMS';
export const REMOVE_BIND_SUCCESS = 'REMOVE_BIND_SUCCESS';
export const REMOVE_BIND_FAILURE = 'REMOVE_BIND_FAILURE';
export const RESOLVE_REMOVE_BIND_PARAMS = 'RESOLVE_REMOVE_BIND_PARAMS';

// authEdit
export const GET_SYSTEM_AUTH_TABLE_REQUEST = 'GET_SYSTEM_AUTH_TABLE_REQUEST';
export const GET_SYSTEM_AUTH_TABLE_SUCCESS = 'GET_SYSTEM_AUTH_TABLE_SUCCESS';
export const GET_SYSTEM_AUTH_TABLE_FAILURE = 'GET_SYSTEM_AUTH_TABLE_FAILURE';

// roleEdit
export const GET_SYSTEM_AUTH_TPL_REQUEST = 'GET_SYSTEM_AUTH_TPL_REQUEST';
export const GET_SYSTEM_AUTH_TPL_SUCCESS = 'GET_SYSTEM_AUTH_TPL_SUCCESS';
export const GET_SYSTEM_AUTH_TPL_FAILURE = 'GET_SYSTEM_AUTH_TPL_FAILURE';

// roleList
export const GET_ROLE_LIST_REQUEST = 'GET_ROLE_LIST_REQUEST';
export const GET_ROLE_LIST_SUCCESS = 'GET_ROLE_LIST_SUCCESS';
export const GET_ROLE_LIST_FAILURE = 'GET_ROLE_LIST_FAILURE';
export const UPDATE_ROLE_LIST_PARAMS = 'UPDATE_ROLE_LIST_PARAMS';
export const RESET_ROLE_LIST_DATA = 'RESET_ROLE_LIST_DATA';

// predict
export const GET_PREDICT_LIST_REQUEST = 'GET_PREDICT_LIST_REQUEST';
export const GET_PREDICT_LIST_SUCCESS = 'GET_PREDICT_LIST_SUCCESS';
export const GET_PREDICT_LIST_FAILURE = 'GET_PREDICT_LIST_FAILURE';
export const UPDATE_PREDICT_LIST_CONFIG = 'UPDATE_PREDICT_LIST_CONFIG';
export const UPDATE_PREDICT_LIST_DATA = 'UPDATE_PREDICT_LIST_DATA';
export const RESOLVE_PREDICT_LIST_PARAMS = 'RESOLVE_PREDICT_LIST_PARAMS';
export const GET_PREDICT_GOODS_INFO_REQUEST = 'GET_PREDICT_GOODS_INFO_REQUEST';
export const GET_PREDICT_GOODS_INFO_SUCCESS = 'GET_PREDICT_GOODS_INFO_SUCCESS';
export const GET_PREDICT_GOODS_INFO_FAILURE = 'GET_PREDICT_GOODS_INFO_FAILURE';
export const GET_PROXY_DETAIL_REQUEST = 'GET_PROXY_DETAIL_REQUEST';
export const GET_PROXY_DETAIL_SUCCESS = 'GET_PROXY_DETAIL_SUCCESS';
export const GET_PROXY_DETAIL_FAILURE = 'GET_PROXY_DETAIL_FAILURE';
export const RESET_PREDICT_PAGE_DATA = 'RESET_PREDICT_PAGE_DATA';


// agencyGoods
export const GET_AGENCY_GOODS_CATES_REQUEST = 'GET_AGENCY_GOODS_CATES_REQUEST';
export const GET_AGENCY_GOODS_CATES_SUCCESS = 'GET_AGENCY_GOODS_CATES_SUCCESS';
export const GET_AGENCY_GOODS_CATES_FAILURE = 'GET_AGENCY_GOODS_CATES_FAILURE';
export const CLEAR_AGENCY_GOODS_CATES = 'CLEAR_AGENCY_GOODS_CATES';
export const GET_AGENCY_LIST_REQUEST = 'GET_AGENCY_LIST_REQUEST';
export const GET_AGENCY_LIST_SUCCESS = 'GET_AGENCY_LIST_SUCCESS';
export const GET_AGENCY_LIST_FAILURE = 'GET_AGENCY_LIST_FAILURE';
export const UPDATE_AGENCY_LIST = 'UPDATE_AGENCY_LIST';
export const UPDATE_AGENCY_LIST_PARAMS = 'UPDATE_AGENCY_LIST_PARAMS';
export const RESET_AGENCY_LIST = 'RESET_AGENCY_LIST';
export const RESOLVE_AGENCY_LIST_PARAMS = 'RESOLVE_AGENCY_LIST_PARAMS';

// addAgencyGoods
export const GET_ADD_AGENCY_GOODS_CATES_REQUEST = 'GET_ADD_AGENCY_GOODS_CATES_REQUEST';
export const GET_ADD_AGENCY_GOODS_CATES_SUCCESS = 'GET_ADD_AGENCY_GOODS_CATES_SUCCESS';
export const GET_ADD_AGENCY_GOODS_CATES_FAILURE = 'GET_ADD_AGENCY_GOODS_CATES_FAILURE';
export const CLEAR_ADD_AGENCY_GOODS_CATES = 'CLEAR_ADD_AGENCY_GOODS_CATES';
export const GET_ADD_AGENCY_LIST_REQUEST = 'GET_ADD_AGENCY_LIST_REQUEST';
export const GET_ADD_AGENCY_LIST_SUCCESS = 'GET_ADD_AGENCY_LIST_SUCCESS';
export const GET_ADD_AGENCY_LIST_FAILURE = 'GET_ADD_AGENCY_LIST_FAILURE';
export const UPDATE_ADD_AGENCY_LIST = 'UPDATE_ADD_AGENCY_LIST';
export const UPDATE_ADD_AGENCY_LIST_PARAMS = 'UPDATE_ADD_AGENCY_LIST_PARAMS';
export const RESET_ADD_AGENCY_LIST = 'RESET_ADD_AGENCY_LIST';
export const RESOLVE_ADD_AGENCY_LIST_PARAMS = 'RESOLVE_ADD_AGENCY_LIST_PARAMS';

// enterStore
export const GET_ENTER_STORE_LIST_REQUEST = 'GET_ENTER_STORE_LIST_REQUEST';
export const GET_ENTER_STORE_LIST_SUCCESS = 'GET_ENTER_STORE_LIST_SUCCESS';
export const GET_ENTER_STORE_LIST_FAILURE = 'GET_ENTER_STORE_LIST_FAILURE';
export const UPDATE_ENTER_STORE_LIST_PARAMS = 'UPDATE_ENTER_LIST_PARAMS';
export const RESET_ENTER_STORE_LIST = 'RESET_ENTER_LIST';
export const RESOLVE_ENTER_STORE_LIST_PARAMS = 'RESOLVE_ENTER_LIST_PARAMS';

// selfGoods
export const GET_SELF_GOODS_LIST_REQUEST = 'GET_SELF_GOODS_LIST_REQUEST';
export const GET_SELF_GOODS_LIST_SUCCESS = 'GET_SELF_GOODS_LIST_SUCCESS';
export const GET_SELF_GOODS_LIST_FAILURE = 'GET_SELF_GOODS_LIST_FAILURE';
export const UPDATE_SELF_GOODS_LIST = 'UPDATE_SELF_GOODS_LIST';
export const UPDATE_SELF_GOODS_LIST_PARAMS = 'UPDATE_SELF_GOODS_LIST_PARAMS';
// export const UPDATE_EXPORT_ORDER_URL = 'UPDATE_EXPORT_ORDER_URL';
// export const UPDATE_WAIT_DATA = 'UPDATE_WAIT_DATA';
export const RESET_SELF_GOODS_LIST = 'RESET_SELF_GOODS_LIST';
export const RESOLVE_SELF_GOODS_LIST_PARAMS = 'RESOLVE_SELF_GOODS_LIST_PARAMS';

export const GET_SELF_GOODS_CATES_REQUEST = 'GET_SELF_GOODS_CATES_REQUEST';
export const GET_SELF_GOODS_CATES_SUCCESS = 'GET_SELF_GOODS_CATES_SUCCESS';
export const GET_SELF_GOODS_CATES_FAILURE = 'GET_SELF_GOODS_CATES_FAILURE';
export const CLEAR_SELF_GOODS_CATES = 'CLEAR_SELF_GOODS_CATES';

// storeGoods
export const STORE_CHOSEN_ITEM = 'STORE_CHOSEN_ITEM';
export const EDIT_STORE_ITEM_PROPS = 'EDIT_STORE_ITEM_PROPS';
export const UPDATE_STORE_GOODS_IDS = 'UPDATE_STORE_GOODS_IDS';
export const INIT_STORE_CHOSEN_GOODS = 'INIT_STORE_CHOSEN_GOODS';
export const INIT_STORE_CHOSEN_GOODS_IDS = 'INIT_STORE_CHOSEN_GOODS_IDS';

// outStore
export const GET_OUT_STORE_LIST_REQUEST = 'GET_OUT_STORE_LIST_REQUEST';
export const GET_OUT_STORE_LIST_SUCCESS = 'GET_OUT_STORE_LIST_SUCCESS';
export const GET_OUT_STORE_LIST_FAILURE = 'GET_OUT_STORE_LIST_FAILURE';
export const UPDATE_OUT_STORE_LIST_PARAMS = 'UPDATE_OUT_LIST_PARAMS';
export const RESET_OUT_STORE_LIST = 'RESET_OUT_LIST';
export const RESOLVE_OUT_STORE_LIST_PARAMS = 'RESOLVE_OUT_LIST_PARAMS';

// 添加商品
export const GET_STORE_ADD_GOODS_CATES_REQUEST = 'GET_STORE_ADD_GOODS_CATES_REQUEST';
export const GET_STORE_ADD_GOODS_CATES_SUCCESS = 'GET_STORE_ADD_GOODS_CATES_SUCCESS';
export const GET_STORE_ADD_GOODS_CATES_FAILURE = 'GET_STORE_ADD_GOODS_CATES_FAILURE';
export const UPDATE_STORE_ADD_GOODS_PARAMS = 'UPDATE_STORE_ADD_GOODS_PARAMS';
export const CLEAR_STORE_ADD_GOODS_CATES = 'CLEAR_STORE_ADD_GOODS_CATES';

// 新建/编辑优惠券
export const POST_EDIT_COUPON_REQUEST = 'POST_EDIT_COUPON_REQUEST';
export const POST_EDIT_COUPONE_SUCCESS = 'POST_EDIT_COUPON_SUCCESS';
export const POST_EDIT_COUPON_FAILURE = 'POST_EDIT_COUPON_FAILURE';
export const RESET_EDIT_COUPON_DATA = 'RESET_EDIT_COUPON_DATA';
// 获取bc优惠券
export const GET_BC_COUPON_REQUEST = 'GET_BC_COUPON_REQUEST';
export const GET_BC_COUPON_SUCCESS = 'GET_BC_COUPON_SUCCESS';
export const GET_BC_COUPON_FAILURE = 'GET_BC_COUPON_FAILURE';
// 上架中的服务列表
export const GET_PUT_SERVICE_LIST_REQUEST = 'GET_PUT_SERVICE_LIST_REQUEST';
export const GET_PUT_SERVICE_LIST_SUCCESS = 'GET_PUT_SERVICE_LIST_SUCCESS';
export const GET_PUT_SERVICE_LIST_FAILURE = 'GET_CLASSIFICATION_LIST_FAILURE';
export const RESET_SELECT_PUT_SERVICE_LIST = 'RESET_SELECT_PUT_SERVICE_LIST';
export const HAS_PUT_SERVICE_MORE = 'HAS_PUT_SERVICE_MORE';
export const REMOVE_SELECT_PUT_SERVICE_ITEM = 'REMOVE_SELECT_PUT_SERVICE_ITEM';
// 上架中的爱车卡列表
export const RESET_SELECT_STORE_CARD_LIST = 'RESET_SELECT_STORE_CARD_LIST';
export const REMOVE_SELECT_STORE_CARD_ITEM = 'REMOVE_SELECT_STORE_CARD_ITEM';
export const HAS_CAR_CARD_MORE = 'HAS_CAR_CARD_MORE';
// 上架中的营销活动列表
export const GET_MARKETING_ACTIVITY_LIST_REQUEST = 'GET_MARKETING_ACTIVITY_LIST_REQUEST';
export const GET_MARKETING_ACTIVITY_LIST_SUCCESS = 'GET_MARKETING_ACTIVITY_LIST_SUCCESS';
export const GET_MARKETING_ACTIVITY_FAILURE = 'GET_MARKETING_ACTIVITY_FAILURE';
export const RESET_SELECT_MARKETING_ACTIVITY_LIST = 'RESET_SELECT_MARKETING_ACTIVITY_LIST';
export const REMOVE_SELECT_MARKETING_ACTIVITY_ITEM = 'REMOVE_SELECT_MARKETING_ACTIVITY_ITEM';
export const HAS_MARKETING_ACTIVITY_MORE = 'HAS_MARKETING_ACTIVITY_MORE';

// 商品订单
export const GET_GOODS_ORDER_LIST_REQUEST = 'GET_GOODS_ORDER_LIST_REQUEST';
export const GET_GOODS_ORDER_LIST_SUCCESS = 'GET_GOODS_ORDER_LIST_SUCCESS';
export const GET_GOODS_ORDER_LIST_FAILURE = 'GET_GOODS_ORDER_LIST_FAILURE';
export const UPDATE_GOODS_ORDER_LIST_PARAMS = 'UPDATE_GOODS_ORDER_LIST_PARAMS';
export const GOODS_ORDER_LIST_CONFIG_RESET = 'GOODS_ORDER_LIST_CONFIG_RESET';
// 占用次数说明列表
export const GET_OCCUPY_LIST_REQUEST = 'GET_OCCUPY_LIST_REQUEST';
export const GET_OCCUPY_LIST_SUCCESS = 'GET_OCCUPY_LIST_SUCCESS';
export const GET_OCCUPY_LIST_FAILURE = 'GET_OCCUPY_LIST_FAILURE';
// b2bOrderGoods
export const GET_B2B_GOODS_LIST_REQUEST = 'GET_B2B_GOODS_LIST_REQUEST';
export const GET_B2B_GOODS_LIST_SUCCESS = 'GET_B2B_GOODS_LIST_SUCCESS';
export const GET_B2B_GOODS_LIST_FAILURE = 'GET_B2B_GOODS_LIST_FAILURE';
export const UPDATE_B2B_GOODS_LIST_PARAMS = 'UPDATE_B2B_GOODS_LIST_PARAMS';
export const B2B_GOODS_LIST_CONFIG_RESET = 'B2B_GOODS_LIST_CONFIG_RESET';

// carsDetail
export const GET_MAINTAIN_LIST_SUCCESS = 'GET_MAINTAIN_LIST_SUCCESS';
export const DELETE_MAINTAIN_ITEM = 'DELETE_MAINTAIN_ITEM';



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js